module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "fashion-view"
  }, [_c('header', {
    staticClass: "cover fashion-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.subtitle')))])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#ruyi-brand-network', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-01",
    attrs: {
      "id": "ruyi-brand-network"
    }
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline"
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-01.title')))]), _vm._v(" "), _c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-01.body'))
    }
  })])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#ruyi-brand-network', 'up')
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#smcp', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-02"
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline px-0",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-04.title'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-01"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image01.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image01.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image01.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-02"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image02.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image02.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image02.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-03",
    attrs: {
      "id": "smcp"
    }
  }, [_c('div', {
    staticClass: "text-block-body"
  }, [_c('h4', {
    staticClass: "brand",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-03.title'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-03.body'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "font-weight-bold",
    attrs: {
      "href": _vm.$t('pages.fashion.text-block-03.website'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-03.website')) + " "), _c('i', {
    staticClass: "iconfont icon-angle-right iconfont-lg"
  })])])])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#smcp', 'up')
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#renown', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-04"
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline px-0",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-04.title'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-03"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image03.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image03.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image03.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-04"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image04.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image04.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image04.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-05",
    attrs: {
      "id": "renown"
    }
  }, [_c('div', {
    staticClass: "text-block-body"
  }, [_c('h4', {
    staticClass: "brand",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-05.title'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-05.body'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "font-weight-bold",
    attrs: {
      "href": _vm.$t('pages.fashion.text-block-05.website'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-05.website')) + " "), _c('i', {
    staticClass: "iconfont icon-angle-right iconfont-lg"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-05 d-none d-md-block"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image05.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image05.md))
    }
  }), _vm._v(" "), _c('img')])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#renown', 'up')
      }
    }
  })], 1)]), _vm._v(" "), _c('in-page-nav', {
    attrs: {
      "links": _vm.inPageLinks,
      "active": _vm.inPageNavActive
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02bf4932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Fashion.vue
// module id = 617
// module chunks = 1